/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Title_NumberInputs */



/**
* | output |
* | --- |
* | "TI #" |
*
* @param {Ccsl_Export_Header_Title_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_title_number = /** @type {((inputs?: Ccsl_Export_Header_Title_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Title_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("TI #")
	if (locale === "de") return /** @type {LocalizedString} */ ("TI #")
	if (locale === "it") return /** @type {LocalizedString} */ ("TI #")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ТИ #")
	if (locale === "es") return /** @type {LocalizedString} */ ("TI #")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("TI #")
	if (locale === "ja") return /** @type {LocalizedString} */ ("TI #")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीआई #")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("TI #")
	return /** @type {LocalizedString} */ ("TI #")
});